<script>
export default {
  props: {
    videoLink: {
      type: String,
      default: '',
    },
    display: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {},
  mounted: function() {},
  methods: {
    closeModal() {
      this.display = false
      this.$emit('clicked', 'closedModal')
    },
  },
}
</script>

<template>
  <div>
    <Modal v-model="display" :closable="false" class="modalStyles">
      <div>
        <slot />
      </div>
      <div slot="footer"> </div>
    </Modal>
  </div>
</template>

<style lang="scss">
@import '@design';

.modalStyles {
  /* stylelint-disable */
  .ivu-modal {
    width: 80vw !important;
    height: 80vh !important;
  }
  .ivu-modal-content {
    padding: 0px;
    color: transparent;
    background-color: transparent;
    height: 100%;
  }
  .closeBtn {
    position: absolute;
    top: 35px;
    right: 35px;
    background: none;
    border: solid 2px #fff;
    z-index: 50;
  }
  .ivu-modal-footer {
    display: none;
  }

  /* stylelint-enable */
}
</style>
